import { render, staticRenderFns } from "./QProductLibraryAdminSubmenu.vue?vue&type=template&id=3490c195&"
import script from "./QProductLibraryAdminSubmenu.vue?vue&type=script&lang=js&"
export * from "./QProductLibraryAdminSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports